// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statusText[data-v-ad19ba22] {\n  display: inline-block;\n  padding: 0.25em 1em;\n  border-radius: 4px;\n  font-weight: bold;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
